import { faPowerOff } from "@fortawesome/pro-duotone-svg-icons/faPowerOff";

import { type Breadcrumb } from "@application/types/breadcrumb";

export const LOGOUT_LINK: Breadcrumb = {
  icon: faPowerOff,
  name: "Logout",
  to: "/logout",
};
